// @flow

import React, { type ComponentType } from 'react';
import ButtonBar from './buttonBar';
import { ACFButton, type ACFProps as ACFButtonProps } from '../button';

export type ACFProps = {
  direction: 'row' | 'column',
  justify: 'flex-start' | 'flex-end' | 'center' | 'space-between',
  buttons: Array<ACFButtonProps>,
  IconComponent: ?ComponentType<*>,
};

const ACFButtonBar = ({
  direction,
  justify,
  buttons,
  IconComponent,
}: ACFProps) => (
  <ButtonBar
    direction={direction}
    justify={justify}
  >
    {buttons && buttons.map((button, index) => (
      <ACFButton
        key={index} // eslint-disable-line react/no-array-index-key
        {...button}
        IconComponent={IconComponent}
      />
    ))}
  </ButtonBar>
);

export default ACFButtonBar;
